import { CIcon } from '~/icons/types'

export const ciCargoBike: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M3.666 17.492a3.405 3.405 0 1 1 3.406-3.405 3.41 3.41 0 0 1-3.406 3.405Zm0-5.81a2.405 2.405 0 1 0 2.406 2.405 2.408 2.408 0 0 0-2.406-2.405Zm13.404 5.81a3.405 3.405 0 1 1 3.405-3.405 3.41 3.41 0 0 1-3.406 3.405Zm0-5.81a2.405 2.405 0 1 0 2.405 2.405 2.408 2.408 0 0 0-2.406-2.405Z'
    },
    {
      d:
        'M8.56 14.588H3.564a.5.5 0 0 1-.426-.762L5.89 9.332a.5.5 0 1 1 .853.523l-2.288 3.733H8.56a.5.5 0 0 1 0 1Z'
    },
    {
      d:
        'M14.044 14.588H8.56a.5.5 0 0 1-.459-.301L5.73 8.839a.5.5 0 0 1 .917-.399l2.242 5.148h5.156a.5.5 0 0 1 0 1Z'
    },

    {
      d:
        'M7.109 8.932h-.002L5.35 8.926a.5.5 0 0 1 .001-1h.002l1.758.006a.5.5 0 0 1-.001 1Zm12.901 5.691a.5.5 0 0 1-.353-.854l2.264-2.263v-2.58h-9.388v5.162a.5.5 0 0 1-1 0V8.426a.5.5 0 0 1 .5-.5H22.42a.5.5 0 0 1 .5.5v3.287a.5.5 0 0 1-.146.353l-2.41 2.41a.498.498 0 0 1-.354.147Z'
    },
    {
      d:
        'M12.032 8.926a.5.5 0 0 1-.498-.465 1.023 1.023 0 0 0-.623-.895 1.05 1.05 0 0 0-.84.076.5.5 0 1 1-.491-.87 1.965 1.965 0 0 1 2.952 1.619.5.5 0 0 1-.464.534h-.036Z'
    },
    {
      d:
        'M10.116 14.092a1.325 1.325 0 1 1-1.33-1.33 1.327 1.327 0 0 1 1.33 1.33Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'cargo-bike',
  type: 'thin'
}
